import { createStore } from 'vuex'

export default createStore({
    state: {
        baseUrl: 'https://inkai.info/api/'
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})
